<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1875955" style="color: #82a339"><b>PASTA E PISELLI</b></p>
<p class="ext" id="d7e1876755"><b><i>Here is a quick weeknight version of pasta e fagiole. In season, use fresh peas (piselli). Cook them in the broth until tender before adding the pasta.</i></b></p>
<p class="h4" id="d7e1878655" style="color: #496210"><b>Prep: 10 minutes plus cooking pasta Cook: 20 minutes</b></p>
<p class="ul" id="d7e1879455">2 tablespoons olive oil</p>
<p class="ul" id="d7e1879755">3 garlic cloves, crushed with side of chef’s knife</p>
<p class="ul" id="d7e1880055">1 can (14½ ounces) diced tomatoes</p>
<p class="ul" id="d7e1881155">2 cans (14½ ounces each) chicken broth <br/> or 3½ cups Chicken Broth</p>
<p class="ul" id="d7e1883555">½ cup water</p>
<p class="ul" id="d7e1884455">¼ cup loosely packed fresh basil leaves, <br/> coarsely chopped</p>
<p class="ul" id="d7e1885755">8 ounces mixed pasta, such as penne, bow ties, <br/> or elbow macaroni (2 cups), cooked <br/> as label directs</p>
<p class="ul" id="d7e1887255">1 package (10 ounces) frozen peas, thawed <br/> freshly grated Parmesan cheese</p>
<p class="pub" id="d7e1888055" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In nonreactive 4-quart saucepan, heat oil over medium heat. Add garlic; cook, stirring frequently, until golden, about 2 minutes.</p>
<p class="pub" id="d7e1889655"><span style="color: #c15b49"><b>2.</b></span> Add tomatoes with their juice, broth, water, and basil; heat to boiling. Reduce heat; cover and simmer 5 minutes. Discard garlic.</p>
<p class="pub" id="d7e1891055"><span style="color: #c15b49"><b>3.</b></span> Stir in pasta and peas; heat through. Serve with grated Parmesan. Makes about 10 cups or 5 main-dish servings.</p>
<p class="ntx" id="d7e1892755">Each serving without Parmesan: About 317 calories, 12g protein, 51g carbohydrate, 8g total fat (1g saturated), 0mg cholesterol, 1,044mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c51_r1.vue?22ca1694